import * as React from 'react'

import {BrowserRouter,Switch, Redirect} from 'react-router-dom'
import {PublicRoute} from './routes/PublicRoute'
import {PrivateRoute} from './routes/PrivateRoute'

import HomeScreen from './pages/public/Home'
import RegisterScreen from './pages/public/Register'
import {Dashboard} from './pages/private/Dashboard'

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <PublicRoute exact path='/' restricted={false} component={HomeScreen}/>
        <PublicRoute exact path='/register' restricted={false} component={RegisterScreen} />
        <PrivateRoute exact path='/dashboard' component={Dashboard}  />
        <Redirect to='/'/>
      </Switch>
    </BrowserRouter>
  );
}

export default App

